import { Component,ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router'
import { session } from '../../../../environments/environment.session'
import { DashboardService } from '../../service/dashboard.service'
import { SpinnerService } from '../../../shared/spinner.service'
import { ComplaintsService } from '../../service/complaints.service'
import Swal from 'sweetalert2';
import { PdfGeneratorService } from '../../service/pdf-generator.service';

@Component({
  selector: 'app-pending-complaints',
  templateUrl: './pending-complaints.component.html',
  styleUrls: ['./pending-complaints.component.css']
})
export class PendingComplaintsComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = ['id', 'ticket_id', 'dateTime', 'zone', 'days_open','status','action'];

  dataSource = [
    // { id: 1, name: 'John Doe', age: 20 },
    // { id: 2, name: 'Jane Smith', age: 22 },
    // { id: 3, name: 'Alice Johnson', age: 24 },
    // { id: 1, name: 'John Doe', age: 20 },
    // { id: 2, name: 'Jane Smith', age: 22 },
    // { id: 3, name: 'Alice Johnson', age: 24 }
  ];

  complaints = new MatTableDataSource(this.dataSource);
  constructor(private pdfService: PdfGeneratorService,private router: Router ,private dashboardService:DashboardService ,private tspinner: SpinnerService, private cs: ComplaintsService) { }
  erpUser: any
  resolved_count: number = 0
  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser))
    this.complaints.filterPredicate = (data, filter: string) => {
      const dataStr = Object.values(data).join('').toLowerCase();
      return dataStr.includes(filter);
    }
    console.log("check")
    this.getComplaints()





  }
onDownloadPDF(element: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, element.com_id);
  }
  department = {}
  async getComplaints() {

    let obj = { b_acct_id: this.erpUser.b_acct_id, user_id:this.erpUser.le_id,life_cycle_status:'PENDING'};
    this.tspinner.show('', '')
    let resp = await this.cs.getComplaints(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.tspinner.hide()
      resp.data.map((complaint: any) => {
        try {
          const deptArray = JSON.parse(complaint.dept || '[]');
          complaint.departments = deptArray.map((item: any) => Object.values(item));
        } catch (err) {
          complaint.departments = [];
        }
        return complaint;
      });


      this.complaints = new MatTableDataSource(resp['data'])
      this.complaints.paginator = this.paginator;
      return
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
      return
    }

  }
  applyFilter(filterValue: string) {
    this.complaints.filter = filterValue.trim().toLowerCase();
  }
route(element: any) {
    this.router.navigate(['/sdp/officer/update-complaints'], {
      state: { data: element }
    });
  }
  route1(element: any) {
    this.router.navigate(['sdp/complaints/preview'], {
      state: { data: element }
    });
  }
}
